import { createSelector } from '@reduxjs/toolkit';
import { isNil } from 'lodash/fp';
import {
    selectIsInMaintenance as selectMaintenanceStatusFromHeartbeat,
    selectIsSuspended as selectSuspendedStatusFromHeartbeat
} from 'app/store/websocketStatus/selectors';
import {
    selectIsInMaintenance as selectMaintenanceStatusFromHealthCheck,
    selectIsSuspended as selectSuspendedStatusFromHealthCheck
} from 'app/store/healthcheck/selectors';

export const selectIsInMaintenance = createSelector(
    [selectMaintenanceStatusFromHealthCheck, selectMaintenanceStatusFromHeartbeat],
    (statusFromHealthcheck, statusFromHeartbeat) => {
        if (isNil(statusFromHeartbeat)) {
            return null;
        }
        return statusFromHealthcheck || statusFromHeartbeat;
    }
);

export const selectIsSuspended = createSelector(
    [selectSuspendedStatusFromHealthCheck, selectSuspendedStatusFromHeartbeat],
    (statusFromHealthcheck, statusFromHeartbeat) => {
        if (isNil(statusFromHeartbeat)) {
            return null;
        }
        return statusFromHealthcheck || statusFromHeartbeat;
    }
);
